import {$} from '../utils';

// Tab component
const Accordion = () => {
    // Looping through each wrapper
    $('.accordion', (wrapper) => {
        // All items
        const items = wrapper.querySelectorAll('.ac-item');
        // All buttons
        const buttons = wrapper.querySelectorAll('.ac-item .ac-click');
        // Each button
        $(buttons, (button, index) => {
            // Add height to active item
            if (button.parentElement.classList.contains('active')) {
                const content = button.nextElementSibling;
                content.style.maxHeight = content.scrollHeight + 'px';
            }

            // Add event listener
            button.addEventListener('click', (e) => {
                // Prevent default action
                e.preventDefault();
                // Get content box
                const contentBox = button.nextElementSibling;

                // If item is already active
                if (items[index].classList.contains('active')) {
                    // Remove active class for all items
                    items[index].classList.remove('active');
                    // Add height
                    contentBox.style.maxHeight = "0px";
                    // Return
                    return;
                }
                // Remove active class for all items
                // $(items).removeClass('active');
                // All buttons
                // $(buttons, (btn, x) => {
                //     // Remove height form
                //     if (x !== index) btn.nextElementSibling.style.maxHeight = "0px";
                // });
                // Add active class to item
                items[index].classList.add('active');
                // Add height
                contentBox.style.maxHeight = contentBox.scrollHeight + "px";
            });
        });
    });
};

// Export component
export default Accordion;